export default __webpack_public_path__ + "static/selfPortrait-d6048d3ff3da15534ddebd1d956f9713.png";